import { NgModule } from '@angular/core';
import { NumberAbbreviatorPipe } from './number-abbreviator.pipe';

@NgModule({
    declarations: [NumberAbbreviatorPipe],
    exports: [NumberAbbreviatorPipe],
})
export class NumberAbbreviatorPipeModule {}
